'use strict';

export default class ModalFastViewSlider {
	constructor() {
		this.slider = document.querySelector('[data-fast-view-slider]:not(.is-inited)');
		if (!this.slider) return false;
		this.main = document.querySelector('[data-fast-view-slider-main]');
		this.thumbs = document.querySelector('[data-fast-view-slider-thumbs]');

		this.initSlider();
	}

	initSlider(){
		$(this.main).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
			asNavFor: this.thumbs,
		})
		
		$(this.thumbs).slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			infinite: false,
			asNavFor: this.main,
			focusOnSelect: true,
		})

		this.slider.classList.add('is-inited');
	}
}
